import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import FooterLinks from "../components/FooterLinks";
import bannerImage from "../assets/banner4.png";
import { Helmet } from "react-helmet-async";
import "../PracticeTests.css"; 
import '../Site.css'; 


function PracticeTest() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const API_URL = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    if (!user) {
      navigate("/login"); // Redirect if not logged in
      return;
    }

    async function fetchUserTests() {
      try {
        const response = await fetch(`${API_URL}/api/tests/${user.Id}/subscriptions`);
        if (!response.ok) throw new Error("Failed to fetch tests");

        const data = await response.json();
        setTests(data.tests || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchUserTests();
  }, [user, navigate]);

  const handleStartTest = (testId) => {
    navigate(`/test/${testId}`);
  };

  return (
    <><>
      <Helmet>
        <title>PharmPrepPro - Practice Tests</title>
      </Helmet>

      <BottomContainer>
        <Banner
          height="300px"

          image={bannerImage} />

        <BodyContainer>
          <h1 className="test-header">Available Practice Tests</h1>

          {loading ? (
            <p className="no-tests-message">Loading tests...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : tests.length === 0 ? (
            <p className="no-tests-message">You have no active test subscriptions.</p>
          ) : (
            <ul className="test-list">
              {tests.map((test) => (
                <li key={test.Id} className="test-item">
                  <span className="test-name">{test.Name}</span>
                  <button className="start-button" onClick={() => handleStartTest(test.Id)}>
                    Start Exam
                  </button>
                </li>
              ))}
            </ul>
          )}
        </BodyContainer>

      </BottomContainer>
    </><FooterLinks /><Footer /></>
  );
}

export default PracticeTest;
